export enum PhaseNames {
  NotSet = 'notSet',
  InProgress = 'ONGOING',
  ReadyForWarranty = 'TO_COMPLETE',
  WarrantyInProgress = 'COMPLETED',
  ReadyToArchive = 'TO_ARCHIVE',
  Archived = 'archived',
  Inactive = 'INACTIVE',
}

export interface IrisProjectPhasesI {
  name: PhaseNames;
  color: string;
  label: string;
}
